/*
 * SPDX-FileCopyrightText: 2026 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { AsyncPipe, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { TranslatePipe } from '@spartacus/core';
import { QuoteCommentsComponent } from '@spartacus/quote/components';
import { IconComponent, MessagingComponent, MessagingConfigs } from '@spartacus/storefront';
import { map } from 'rxjs';

const DEFAULT_COMMENT_MAX_CHARS = 1000;
const ALL_PRODUCTS_ID = '';

@Component({
  selector: 'cx-quote-comments',
  templateUrl: './quote-comments.component.html',
  imports: [NgIf, IconComponent, MessagingComponent, AsyncPipe, TranslatePipe],
})
export class CustomQuoteCommentsComponent extends QuoteCommentsComponent {
  protected override prepareMessagingConfigs(): MessagingConfigs {
    return {
      charactersLimit: this.quoteUIConfig.quote?.maxCharsForComments ?? DEFAULT_COMMENT_MAX_CHARS,
      displayAddMessageSection: this.quoteDetails$.pipe(map((quote) => quote.isEditable)),
      dateFormat: 'MMMM d, yyyy h:mm aa',
      defaultItemId: ALL_PRODUCTS_ID,
      itemList$: this.prepareItemList(),
      sendBtnIsNotPrimary: true,
      newMessagePlaceHolder:
        'Describe your request in detail (process/product parameters, delivery, expected discount etc.)',
    };
  }
}
